export const safeJson = (value, fallback = null) => {
  if (value === null || value === undefined || value === "") return fallback;
  if (typeof value === "object") return value;
  try { return JSON.parse(value); } catch { return fallback; }
};

export const agentEvidence = (run) => {
  const output = safeJson(run?.outputSummary, {});
  return {
    summary: output?.summary || run?.inputSummary || "",
    filesChanged: Array.isArray(output?.filesChanged) ? output.filesChanged : [],
    blockers: Array.isArray(output?.blockers) ? output.blockers : [],
    tests: Array.isArray(output?.tests) ? output.tests : [],
    raw: output,
  };
};

export const eventEvidence = (event) => safeJson(event?.structuredPayload, {});

export const mergeEvents = (current = [], incoming = []) => {
  const byId = new Map(current.map(event => [event.id, event]));
  incoming.forEach(event => byId.set(event.id, event));
  return [...byId.values()].sort((a, b) => (a.sequence || 0) - (b.sequence || 0));
};

export const lastEventSequence = (events = []) => Math.max(0, ...events.map(event => event.sequence || 0));
